/* ==========================================================================
   DevOcean Labs — Design System
   Single source of truth for type, color, spacing, radii, shadow, motion.
   ========================================================================== */

/* --------------------------------------------------------------------------
   1. Web fonts — self-hosted under /fonts/
   -------------------------------------------------------------------------- */

@font-face { font-family:'Baloo Bhaijaan 2'; font-style:normal; font-weight:400; font-display:swap;
  src:url('/fonts/baloo-bhaijaan-2-latin-400-normal.woff2') format('woff2');
  unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD; }
@font-face { font-family:'Baloo Bhaijaan 2'; font-style:normal; font-weight:500; font-display:swap;
  src:url('/fonts/baloo-bhaijaan-2-latin-500-normal.woff2') format('woff2');
  unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD; }
@font-face { font-family:'Baloo Bhaijaan 2'; font-style:normal; font-weight:600; font-display:swap;
  src:url('/fonts/baloo-bhaijaan-2-latin-600-normal.woff2') format('woff2');
  unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD; }
@font-face { font-family:'Baloo Bhaijaan 2'; font-style:normal; font-weight:700; font-display:swap;
  src:url('/fonts/baloo-bhaijaan-2-latin-700-normal.woff2') format('woff2');
  unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD; }
@font-face { font-family:'Baloo Bhaijaan 2'; font-style:normal; font-weight:800; font-display:swap;
  src:url('/fonts/baloo-bhaijaan-2-latin-800-normal.woff2') format('woff2');
  unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD; }

@font-face { font-family:'Baloo Bhaijaan 2'; font-style:normal; font-weight:400; font-display:swap;
  src:url('/fonts/baloo-bhaijaan-2-arabic-400-normal.woff2') format('woff2');
  unicode-range:U+0600-06FF,U+0750-077F,U+08A0-08FF,U+FB50-FDFF,U+FE70-FEFF; }
@font-face { font-family:'Baloo Bhaijaan 2'; font-style:normal; font-weight:500; font-display:swap;
  src:url('/fonts/baloo-bhaijaan-2-arabic-500-normal.woff2') format('woff2');
  unicode-range:U+0600-06FF,U+0750-077F,U+08A0-08FF,U+FB50-FDFF,U+FE70-FEFF; }
@font-face { font-family:'Baloo Bhaijaan 2'; font-style:normal; font-weight:600; font-display:swap;
  src:url('/fonts/baloo-bhaijaan-2-arabic-600-normal.woff2') format('woff2');
  unicode-range:U+0600-06FF,U+0750-077F,U+08A0-08FF,U+FB50-FDFF,U+FE70-FEFF; }
@font-face { font-family:'Baloo Bhaijaan 2'; font-style:normal; font-weight:700; font-display:swap;
  src:url('/fonts/baloo-bhaijaan-2-arabic-700-normal.woff2') format('woff2');
  unicode-range:U+0600-06FF,U+0750-077F,U+08A0-08FF,U+FB50-FDFF,U+FE70-FEFF; }
@font-face { font-family:'Baloo Bhaijaan 2'; font-style:normal; font-weight:800; font-display:swap;
  src:url('/fonts/baloo-bhaijaan-2-arabic-800-normal.woff2') format('woff2');
  unicode-range:U+0600-06FF,U+0750-077F,U+08A0-08FF,U+FB50-FDFF,U+FE70-FEFF; }

@font-face { font-family:'Nunito'; font-style:normal; font-weight:400; font-display:swap;
  src:url('/fonts/nunito-latin-400-normal.woff2') format('woff2'); }
@font-face { font-family:'Nunito'; font-style:normal; font-weight:600; font-display:swap;
  src:url('/fonts/nunito-latin-600-normal.woff2') format('woff2'); }
@font-face { font-family:'Nunito'; font-style:normal; font-weight:700; font-display:swap;
  src:url('/fonts/nunito-latin-700-normal.woff2') format('woff2'); }
@font-face { font-family:'Nunito'; font-style:normal; font-weight:800; font-display:swap;
  src:url('/fonts/nunito-latin-800-normal.woff2') format('woff2'); }
@font-face { font-family:'Nunito'; font-style:normal; font-weight:900; font-display:swap;
  src:url('/fonts/nunito-latin-900-normal.woff2') format('woff2'); }
@font-face { font-family:'Nunito'; font-style:italic; font-weight:900; font-display:swap;
  src:url('/fonts/nunito-latin-900-italic.woff2') format('woff2'); }

/* --------------------------------------------------------------------------
   2. Design tokens
   -------------------------------------------------------------------------- */
:root {
  /* Type families */
  --font-latin:    'Baloo Bhaijaan 2', system-ui, -apple-system, 'Segoe UI', sans-serif;
  --font-arabic:   'Baloo Bhaijaan 2', 'Tajawal', system-ui, sans-serif;
  --font-wordmark: 'Nunito', sans-serif;
  --font-mono:     ui-monospace, 'SF Mono', Menlo, Consolas, monospace;

  /* Type scale */
  --fs-11: 0.6875rem;
  --fs-12: 0.75rem;
  --fs-13: 0.8125rem;
  --fs-14: 0.875rem;
  --fs-16: 1rem;
  --fs-18: 1.125rem;
  --fs-20: 1.25rem;
  --fs-24: 1.5rem;
  --fs-30: 1.875rem;
  --fs-36: 2.25rem;
  --fs-48: 3rem;
  --fs-64: 4rem;
  --fs-80: 5rem;

  /* Weights */
  --fw-regular: 400;
  --fw-medium:  500;
  --fw-semibold:600;
  --fw-bold:    700;
  --fw-extra:   800;

  /* Line-height */
  --lh-tight:   1.1;
  --lh-snug:    1.25;
  --lh-normal:  1.5;
  --lh-relaxed: 1.6;

  /* Letter-spacing */
  --ls-display: -0.02em;
  --ls-tight:   -0.01em;
  --ls-normal:  0;
  --ls-wide:    0.04em;
  --ls-eyebrow: 0.12em;

  /* Tlaaq palette */
  --tlaaq-blue-900: #0B2A6B;
  --tlaaq-blue-700: #1E46B8;
  --tlaaq-blue-500: #2557E8;
  --tlaaq-blue-300: #6B8EF5;
  --tlaaq-blue-100: #EEF3FF;
  --tlaaq-coral-600:#E85D3C;
  --tlaaq-coral-500:#FF7A59;
  --tlaaq-coral-100:#FFE8E0;

  /* Brand (defaults to Tlaaq) */
  --brand-900: var(--tlaaq-blue-900);
  --brand-700: var(--tlaaq-blue-700);
  --brand-500: var(--tlaaq-blue-500);
  --brand-300: var(--tlaaq-blue-300);
  --brand-100: var(--tlaaq-blue-100);
  --accent-600: var(--tlaaq-coral-600);
  --accent-500: var(--tlaaq-coral-500);
  --accent-100: var(--tlaaq-coral-100);

  /* Neutrals */
  --ink-900: #0F172A;
  --ink-800: #1E293B;
  --ink-700: #334155;
  --ink-600: #475569;
  --ink-500: #64748B;
  --ink-400: #94A3B8;
  --ink-300: #CBD5E1;
  --ink-200: #E2E8F0;
  --ink-100: #F1F5F9;
  --ink-50:  #F8FAFC;
  --white:   #FFFFFF;
  --black:   #000000;

  /* Semantic / feedback */
  --success:     #10B981;
  --success-100: #D1FADF;
  --success-700: #065F46;
  --warning:     #F59E0B;
  --warning-100: #FEF3C7;
  --warning-700: #92400E;
  --danger:      #EF4444;
  --danger-100:  #FEE2E2;
  --danger-700:  #991B1B;
  --info:        #3B82F6;
  --info-100:    #DBEAFE;
  --info-700:    #1E40AF;

  /* Surfaces */
  --bg:         var(--ink-50);
  --bg-card:    var(--white);
  --bg-subtle:  var(--ink-100);
  --bg-inverse: var(--ink-900);

  /* Foreground */
  --fg:          var(--ink-900);
  --fg-muted:    var(--ink-600);
  --fg-subtle:   var(--ink-500);
  --fg-disabled: var(--ink-400);
  --fg-on-brand: var(--white);
  --fg-on-dark:  var(--white);

  /* Borders */
  --border-subtle:  var(--ink-200);
  --border-default: var(--ink-300);
  --border-strong:  var(--ink-500);
  --border-brand:   var(--brand-500);
  --border-focus:   var(--brand-500);

  /* Radius */
  --r-xs:  4px;
  --r-sm:  8px;
  --r-md:  12px;
  --r-lg:  16px;
  --r-xl:  22px;
  --r-2xl: 32px;
  --r-pill:999px;

  /* Spacing — 4-pt scale */
  --sp-1:  4px;
  --sp-2:  8px;
  --sp-3:  12px;
  --sp-4:  16px;
  --sp-5:  20px;
  --sp-6:  24px;
  --sp-8:  32px;
  --sp-10: 40px;
  --sp-12: 48px;
  --sp-16: 64px;
  --sp-20: 80px;
  --sp-24: 96px;

  /* Shadows */
  --shadow-xs:   0 1px 2px rgba(15, 23, 42, 0.05);
  --shadow-sm:   0 2px 6px rgba(15, 23, 42, 0.06);
  --shadow-soft: 0 4px 20px rgba(37, 87, 232, 0.08);
  --shadow-card: 0 12px 40px rgba(15, 23, 42, 0.08);
  --shadow-lift: 0 24px 60px rgba(30, 70, 184, 0.18);
  --shadow-focus:0 0 0 3px rgba(37, 87, 232, 0.25);

  /* Gradients */
  --grad-brand: linear-gradient(135deg, var(--brand-500) 0%, var(--brand-700) 60%, var(--brand-900) 100%);
  --grad-sky:   linear-gradient(180deg, var(--brand-100) 0%, var(--bg) 100%);
  --grad-warm:  linear-gradient(135deg, var(--accent-500) 0%, var(--accent-600) 100%);

  /* Motion */
  --ease-out:    cubic-bezier(0.22, 1, 0.36, 1);
  --ease-in-out: cubic-bezier(0.65, 0, 0.35, 1);
  --ease-spring: cubic-bezier(0.34, 1.56, 0.64, 1);
  --dur-fast:    120ms;
  --dur-base:    200ms;
  --dur-slow:    320ms;

  /* Z-index */
  --z-base:    1;
  --z-sticky:  100;
  --z-dropdown:200;
  --z-overlay: 800;
  --z-modal:   1000;
  --z-toast:   1100;

  /* Layout */
  --container:        1200px;
  --container-narrow: 880px;
}

/* --------------------------------------------------------------------------
   3. Base reset
   -------------------------------------------------------------------------- */
*, *::before, *::after { box-sizing: border-box; }

html, body, #root {
  height: 100%;
  margin: 0;
  padding: 0;
}

body {
  font-family: var(--font-latin);
  font-size: var(--fs-16);
  line-height: var(--lh-normal);
  color: var(--fg);
  background: var(--bg);
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}

[dir="rtl"] { font-family: var(--font-arabic); }

button { font-family: inherit; }

a {
  color: var(--brand-700);
  text-decoration: none;
  transition: color var(--dur-fast) var(--ease-out);
}
a:hover { color: var(--brand-500); }

::selection { background: var(--brand-100); color: var(--brand-900); }

:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus);
  border-radius: var(--r-sm);
}

.wordmark {
  font-family: var(--font-wordmark) !important;
  font-style: normal !important;
  font-weight: 800 !important;
}

/* --------------------------------------------------------------------------
   4. Landing skip link — visually hidden until keyboard focus
   -------------------------------------------------------------------------- */
.landing-skip-link {
  position: absolute;
  inset-inline-start: 16px;
  top: -72px;
  z-index: var(--z-toast);
  padding: 10px 18px;
  border-radius: var(--r-sm);
  background: var(--brand-700);
  color: var(--white);
  font-weight: var(--fw-bold);
  font-size: var(--fs-14);
  text-decoration: none;
  transition: top var(--dur-base) var(--ease-out);
}
.landing-skip-link:focus,
.landing-skip-link:focus-visible {
  top: 12px;
  color: var(--white);
  box-shadow: var(--shadow-focus);
}

/* Public information pages include dedicated support navigation and actions. */
body[data-public-page] [data-whatsapp-support-button] {
  display: none;
}
